import { render } from "./EmailList.vue?vue&type=template&id=31548a36&scoped=true"
import script from "./EmailList.vue?vue&type=script&lang=js"
export * from "./EmailList.vue?vue&type=script&lang=js"

import "./EmailList.vue?vue&type=style&index=0&id=31548a36&scoped=true&lang=css"
import "./EmailList.vue?vue&type=style&index=1&id=31548a36&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31548a36"]])

export default __exports__